import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Catalogue } from "@/components/site/Catalogue";
import { StoreStory } from "@/components/site/StoreStory";
import { VisitUs } from "@/components/site/VisitUs";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Catalogue />
        <StoreStory />
        <VisitUs />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
